import "./StainlessSteelFilterMeshMaterials.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import AlloyHero from "./sections/AlloyHero";
import MaterialsGrid from "./sections/MaterialsGrid";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function StainlessSteelFilterMeshMaterialsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="StainlessSteelFilterMeshMaterials" />
      <AlloyHero />
      <MaterialsGrid />
      <QuoteCTA />
      <Footer />
    </div>;
}